import { fromJS } from 'immutable';

import { DEFAULT_LOCALE } from 'constants';

const CHANGE_LOCALE = 'platfi-ui-app/LanguageProvider/CHANGE_LOCALE';

const initialState = fromJS({
  locale: DEFAULT_LOCALE,
});

export function changeLocale(languageLocale) {
  return {
    type: CHANGE_LOCALE,
    locale: languageLocale,
  };
}

export default function languageProviderReducer(state = initialState, action) {
  switch (action.type) {
    case CHANGE_LOCALE:
      return state.set('locale', action.locale);
    default:
      return state;
  }
}
